import styled from 'styled-components';

export const UserStatusesCarouselStyled = styled.div`
    flex: 1;
    pointer-events: none;
    position: relative;
    
    .carousel-slider {
        display: flex;
        flex-direction: column;
        
        // to not hide gradient beyond the carousel
        padding: 200px 0;
        margin: -200px 0;
    }
    .slider-wrapper {
        overflow: unset;
        margin-bottom: 16px;
        pointer-events: auto;
    }
    .control-dots {
        position: unset;
        bottom: -20px;
        margin: 0;
        order: 1;

        .dot {
            margin: 0 2px;
            width: 4px;
            height: 4px;
            border-radius: 2px;
            background: var(--color-label-secondary);
            box-shadow: none;
            opacity: unset;

            &.selected {
                width: 12px;
                background: var(--color-label-primary);
                box-shadow: none;
            }
        }
    }

    .arrow-left, .arrow-right {
        position: absolute;
        top: 50%;
        z-index: 1;
        transform: translateY(-100%);
        pointer-events: auto;
    }

    .arrow-left {
        left: 0;
    }

    .arrow-right {
        right: 0;
    }
`;

export const UserStatusesCarouselItemStyled = styled.div`
    display: flex;
    justify-content: center;
`;

export const UserStatusesCarouselDotsSkeletonStyled = styled.div`
    height: 20px;
    border-radius: 12px;
    width: 70px;
    margin-top: 20px;
`;

interface IUserStatusesCarouselItemBackgroundStyledProps {
    background: string | undefined;
}

export const UserStatusesCarouselItemBackgroundStyled = styled.div<IUserStatusesCarouselItemBackgroundStyledProps>`
    position: absolute;
    top: 50%;
    left: 50%;
    width: 375px;
    height: 375px;
    transform: translate(-50%, -50%);
    background: ${({ background }) => background};
    pointer-events: none;
`;
